import { ListingFormState, PhotoFileType } from '../types';

type NavItemType = {
  label: string;
  id: string;
  checked: boolean;
};
type UseNavItemsType = (obj: {
  listing: ListingFormState;
  photos: PhotoFileType[];
  attachments: PhotoFileType[];
  cards: string[];
  isFormValid: boolean;
}) => NavItemType[];

const useNavItems: UseNavItemsType = ({
  listing,
  photos,
  attachments,
  cards,
  isFormValid,
}) => {
  const isChecked = (keys: (keyof ListingFormState)[]) => {
    const check = (value: any): boolean => {
      const checkEntireObject = (obj: any) => Object.keys(obj).some(subKey => check(obj[subKey]));

      if (Array.isArray(value)) {
        return value.length > 0;
      }
      if (value && typeof value === 'object') {
        return checkEntireObject(value);
      }
      return value || value === 0;
    };

    return keys.some(key => check(listing[key]));
  };

  const result = [
    {
      label: 'Photos',
      id: 'photos',
      checked: photos.length > 0,
    },
    {
      label: 'Virtual Tour',
      id: 'virtualTour',
      checked: !!listing.virtualTourUrl,
    },
    {
      label: 'Description',
      id: 'description',
      checked: isChecked(['client_remarks', 'brokerage_remarks']),
    },
    {
      label: 'Location',
      id: 'location',
      checked: isChecked([
        'dir_cross',
        'fronts_on',
        'taxes',
        'possession',
        'occupancy',
        'legal_description',
      ]),
    },
    {
      label: 'Open Houses',
      id: 'openHouses',
      checked: listing.openHouses.length > 0,
    },
    {
      label: 'Exterior',
      id: 'exterior',
      checked: isChecked([
        'exteriorType',
        'style',
        'exterior',
        'lot_front',
        'lot_depth',
        'garage_type',
        'garage_spaces',
        'drive',
        'parking_spaces',
      ]),
    },
    {
      label: 'More Info',
      id: 'moreInfo',
      checked: isChecked(['more_info']),
    },
    {
      label: 'Condo Details',
      id: 'condoDetails',
      checked: isChecked(['exterior', 'garage_type', 'garage_spaces', 'condo']),
    },
    {
      label: 'Financials',
      id: 'financials',
      checked: isChecked(['financials']),
    },
    {
      label: 'Property Details',
      id: 'propertyDetails',
      checked: isChecked([
        'total_rooms',
        'bedrooms',
        'bathrooms',
        'rooms_plus',
        'bedrooms_plus',
        'kitchens',
        'basement',
        'laundry_access',
        'heat_source',
        'heat_type',
        'ac',
        'age',
        'apx_sqft',
        'sqft',
        'water',
        'utilities',
      ]),
    },
    {
      label: 'Required',
      id: 'required',
      checked: isChecked(['required']),
    },
    {
      label: 'Included / Excluded',
      id: 'includedExcluded',
      checked: isChecked(['freehold']),
    },
    {
      label: 'Rooms',
      id: 'rooms',
      checked: isChecked(['rooms']),
    },
    {
      label: 'Attachments',
      id: 'attachments',
      checked: attachments.length > 0,
    },
  ].filter(({ id }) => cards.includes(id));
  return [
    { label: 'Listing Details', id: 'listingDetails', checked: isFormValid },
    ...result,
  ];
};

export default useNavItems;
